module.exports = __webpack_public_path__ + "static/sonnen-e28b0fd0058569e6504e683f0a9bdd32.webm";